import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/api';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { LayoutService } from 'src/app/layout/service/app.layout.service';

@Component({
    templateUrl: './recuperar-senha.component.html'
})
export class RecuperarSenhaComponent implements OnInit{

	messages: Message[] = [{ severity: 'success', summary: '', detail: '' }]; 
	messagemVisivel: boolean = false;
	cpf?: string = '';
	progressoRequisicao: boolean = false;
	sucessoRequisicao: boolean = false;

    constructor(private usuarioService: UsuarioService,
		private erroService: ErroService,
		private layoutService: LayoutService) {}


	ngOnInit(): void {
		this.sucessoRequisicao = false;
	}

	get dark(): boolean {
		return this.layoutService.config.colorScheme !== 'dark';
	}


	resetarSenha(){
		this.progressoRequisicao = true;
		const usuario: Usuario = {cpf: this.cpf};
		this.usuarioService.resetarSenha(usuario).subscribe({
			next: () => {
				this.messages = [{ severity: 'success', summary: 'Sucesso', detail: 'Nova senha enviada para o seu E-mail' }]; 
          		this.messagemVisivel = true;
				this.progressoRequisicao = false
				this.sucessoRequisicao = true;
			},
			error: (err: any) => {
				this.messages = this.erroService.handleErro(err);
          		this.messagemVisivel = true;
				this.progressoRequisicao = false;
				this.sucessoRequisicao = false;
			}
		});
	}

	liberarReenvio(){
		this.sucessoRequisicao = false;
		this.messagemVisivel = false;
	}

}
